import List from '@/utils/list/index'
const { Table, Search, Operation } = List
import { getSendRecordPage, getActionRecordPage } from '@/api/data/index'
import { $t } from '@/plugin/i18n'
import Dialog from '@/utils/common/dialog'
import DialogTable from '@/utils/common/operation/components/dialog-table.vue'

const search = new Search('data.data.sendRecord')
  .lib('dateTimeRange').prop(['startTime', 'endTime'])

const sendStatusOptions = $t('data.data.sendRecord.sendStatusOptions')
const table = new Table('data.data.sendRecord')
  .add('sendStatus').format(({ value }) => value === '1' ? sendStatusOptions[0] : sendStatusOptions[1])
  .add('supOfficeName').tooltip()
  .add('supOfficeNo')
  .add('operator')
  .add('sendOrCancelTime')

const actionTypeOptions = $t('data.data.sendRecord.actionTypeOptions')
const dialogTable = new Table('data.data.sendRecord')
  .type('index')
  .add('supOfficeName')
  .add('addUserName')
  .add('adddate')
  .add('actionType').format(({ value }) => value === '1' ? actionTypeOptions[0] : actionTypeOptions[1])

const dialog = new Dialog('data.data.sendRecord')
  .title('dialogTitle')
  .component(dialogTable.tpl(DialogTable))
  .bind('$table', dialogTable)
  .isfooter(false)

function recordApi(row: any, rest: any) {
  const params = {
    ...rest[0],
    condition: {
      dataId: row.dataId,
      supOfficeNo: row.supOfficeNo,
      timestamp: row.timestamp,
      ...rest[0].condition
    }
  }
  return getActionRecordPage(params)
}

function handle(this: any, row: any, index: number) {
  dialog.open({ attrs: { index, api: (...rest: any[]) => {
    return recordApi(row, rest)
  } }})
}

const operation = new Operation('data.data.sendRecord')
  .add('detail').handle(handle)

function api(this: any, data: any) {
  const params = {
    ...data,
    condition: {
      ...data.condition,
      dataId: this.$route.params.id,
      field: data.condition.field || 'sendStatus'
    }
  }
  return getSendRecordPage(params)
}

export default new List()
  .api(api)
  .search(search)
  .table(table)
  .operation(operation)
  .end()
